export let FAQ = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Alat apa yang bisa saya gunakan untuk melakukan undian berhadiah?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "<strong><a href=http://undian.prenges.com/>Simulasi Undian Berhadiah</a></strong> adalah alat hebat yang dipercaya dan digunakan oleh banyak perusahaan dan individu untuk memastikan proses undian yang adil dan transparan. Alat ini gratis dan mudah digunakan, yang hanya memerlukan beberapa konfigurasi untuk segera memulai.",
      },
    },
    {
      "@type": "Question",
      name: "Bagaimana cara kerja undian berhadiah?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "Undian berhadiah adalah kompetisi keberuntungan di mana orang-orang secara acak memperoleh tiket bernomor/bernama dan setiap tiket memiliki kesempatan untuk memenangkan hadiah. Tiket bernomor/bernama dipilih secara acak dan pemenang yang terpilih akan membawa pulang hadiah.",
      },
    },
    {
      "@type": "Question",
      name: "Bagaimana cara mengadakan undian berhadiah?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "Perusahaan atau individu mana pun dapat dengan mudah menyelenggarakan undian berhadiah daring hanya dengan menetapkan persyaratan tertentu dan menyiapkan hadiah bagi para pemenang. Alat seperti <strong><a href=http://undian.prenges.com/>Simulator Undian Berhadiah</a></strong> kemudian digunakan untuk memilih pemenang, memastikan proses pengundian yang adil dan transparan.",
      },
    },
    {
      "@type": "Question",
      name: "Apa hadiah undian yang bagus?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "Hadiah seperti Perangkat Elektronik, Keranjang Hadiah, Produk Musiman, Televisi, Voucher Hadiah, dan Voucher Perjalanan adalah ide hadiah undian yang populer.",
      },
    },
  ],
});

export let REVIEW = JSON.stringify({
  "@context": "https://schema.org/",
  "@type": "CreativeWorkSeries",
  name: "Lucky Draw Random Generator Tool",
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5",
    bestRating: "5",
    ratingCount: "689840",
  },
});
